// extracted by mini-css-extract-plugin
module.exports = {"inlineAd":"FO","innerWrapper":"GO","tooltipWrapper":"HO","icon":"IO","tooltip":"JO","content":"KO"};